import CryptoJS from 'crypto-js';

export const encryptAPIKey = (rawApiKey) => {
    if (!rawApiKey) return rawApiKey;

    let secretKeyStr = process.env.REACT_APP_SIGN_IN_SECRET;
    let initVectorStr = process.env.REACT_APP_SIGN_IN_INITIAL_VECTOR;

    if (!secretKeyStr || !initVectorStr) {
        console.error("Missing REACT_APP_SIGN_IN_SECRET or REACT_APP_SIGN_IN_INITIAL_VECTOR in .env");
        return rawApiKey;
    }

    // Standard AES requires 256-bit (32 byte) keys and 128-bit (16 byte) IVs.
    // Python's OpenSSL strictly enforces this. We zero-pad the secrets to match perfectly.
    while (secretKeyStr.length < 32) {
        secretKeyStr += '\0';
    }
    initVectorStr = (initVectorStr + '\0'.repeat(16)).substring(0, 16);

    try {
        const encryptedApiKey = CryptoJS.AES.encrypt(
            rawApiKey,
            CryptoJS.enc.Utf8.parse(secretKeyStr),
            {
                iv: CryptoJS.enc.Utf8.parse(initVectorStr),
                mode: CryptoJS.mode.CBC,
            }
        ).toString();
        
        return encryptedApiKey;
    } catch (e) {
        console.error("Failed to encrypt API key", e);
        return rawApiKey;
    }
};

export const isAlreadyEncrypted = (apiKey) => {
    if (!apiKey) return false;
    let secretKeyStr = process.env.REACT_APP_SIGN_IN_SECRET;
    let initVectorStr = process.env.REACT_APP_SIGN_IN_INITIAL_VECTOR;
    if (!secretKeyStr || !initVectorStr) return false;
    
    while (secretKeyStr.length < 32) {
        secretKeyStr += '\0';
    }
    initVectorStr = (initVectorStr + '\0'.repeat(16)).substring(0, 16);
    
    try {
        const decrypted = CryptoJS.AES.decrypt(
            apiKey,
            CryptoJS.enc.Utf8.parse(secretKeyStr),
            {
                iv: CryptoJS.enc.Utf8.parse(initVectorStr),
                mode: CryptoJS.mode.CBC,
            }
        ).toString(CryptoJS.enc.Utf8);
        return decrypted.length > 0;
    } catch(e) {
        return false;
    }
};
